import CategorizedList from './CategorizedList.jsx';

export default CategorizedList;
